import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-modelo-de-prevencion-de-delitos',
  templateUrl: './modelo-de-prevencion-de-delitos.component.html',
  styleUrls: ['./modelo-de-prevencion-de-delitos.component.css']
})
export class ModeloDePrevencionDeDelitosComponent {

  constructor(private sanitizer: DomSanitizer) { }

  pdfSrc: SafeResourceUrl | undefined;


  loadPdf(pdfName: string) {
    this.pdfSrc = undefined
    //this.pdfSrc = `assets/pdfs/modelo-de-prevencion-de-delitos/${pdfName}`;
    this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl( `assets/pdfs/modelo-de-prevencion-de-delitos/${pdfName}`);
  }

}
